import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react';
import useDanteApi from '@/hooks/useDanteApi';
import * as humanHandoverService from '@/services/human-handover-organization.js';
import ChevronDownIcon from '@/shared/icons/ChevronDownIcon';
import HumanHandoverIcon from '@/shared/icons/HumanHandoverIcon';
import IconWrapper from '@/shared/components/UI/IconWrapper';
import DSpinner from '@/components/Global/DSpinner';

const OrganizationDropdown = () => {
  const navigate = useNavigate();
  const { organization_id } = useParams();

  const {
    isLoading,
    data: dataOrganizations,
  } = useDanteApi(humanHandoverService.getOrganizations);

  const organizations = dataOrganizations?.results || [];
  const currentOrg = organizations.find(
    (org) => org.organization_id === organization_id
  );

  return (
    <Menu>
      {({ open }) => (
        <>
          <div className="flex items-center gap-v3-xxs text-v3-h10 lg:pl-v3-sm font-regular rounded transition-colors">
            <div className="flex items-center gap-v3-xs">
              <IconWrapper size={20}>
                <HumanHandoverIcon className="w-full h-full text-v3-disabled-text" />
              </IconWrapper>
              <span className="truncate max-w-[220px] text-v3-black-max font-medium tracking-tighter flex items-center">
                {isLoading ? (
                  <DSpinner style={{ height: 16, width: 16 }} />
                ) : (
                  currentOrg?.name || 'Organization'
                )}
              </span>
            </div>
            <MenuButton className="group p-1 rounded-v3-lg flex items-center justify-center transition-colors cursor-pointer">
              <IconWrapper size={20}>
                <ChevronDownIcon
                  className={`w-full h-full text-v3-purple-primary hover:text-v3-purple-medium transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
                />
              </IconWrapper>
            </MenuButton>
          </div>

          <MenuItems
            anchor="bottom end"
            className="w-[300px] origin-top-left rounded-v3-lg border border-v3-card-border shadow-v3-card bg-white text-black transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 z-50 flex flex-col overflow-hidden mt-[14px] ml-v3-xhuge"
          >
            {organizations.map((org) => {
              const isSelected = org.organization_id === organization_id;
              return (
                <MenuItem key={org.organization_id}>
                  {({ focus }) => (
                    <button
                      onClick={() => navigate(`/human-handover/${org.organization_id}`)}
                      className={`flex items-center justify-between w-full px-v3-sm py-[8px] md:h-[48px] transition-colors md:rounded-v3-lg ${
                        isSelected ? 'bg-v3-black-lightest' : ''
                      } ${focus ? 'bg-v3-menu-hover' : ''}`}
                    >
                      <span className={`text-sm truncate max-w-[220px] ${isSelected ? 'font-medium text-v3-black-max' : 'font-regular text-v3-black-max'}`}>
                        {org.name}
                      </span>
                    </button>
                  )}
                </MenuItem>
              );
            })}
          </MenuItems>
        </>
      )}
    </Menu>
  );
};

export default OrganizationDropdown;
